import { globalProps } from "neetocommons/initializers";
import { Callout } from "neetoui";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";
import { UAParser } from "ua-parser-js";

import { MOBILE_PLATFORMS } from "./constants";

const DownloadMobileAppCallout = ({ excludePathRegex }) => {
  const { pathname } = useLocation();

  const parser = new UAParser(navigator.userAgent);
  const result = parser.getResult();
  const isMobilePlatform = MOBILE_PLATFORMS.includes(result.os.name);
  if (!isMobilePlatform) return null;

  const shouldExcludePath = excludePathRegex && excludePathRegex.test(pathname);
  if (shouldExcludePath) return null;

  const appName = globalProps.appName?.toLowerCase();
  const mobileAppDownloadUrl = `https://www.neeto.com/${appName}/mobile`;

  return (
    <Callout className="m-4 block" style="warning">
      <Trans
        i18nKey="neetoMolecules.downloadMobileAppCallout.message"
        components={{
          a: (
            <a
              className="neeto-ui-btn--style-link"
              href={mobileAppDownloadUrl}
              rel="noreferrer"
              target="_blank"
            />
          ),
        }}
      />
    </Callout>
  );
};

DownloadMobileAppCallout.propTypes = {
  /**
   * To exclude specific paths where download mobile app callout should be hidden.
   */
  excludePathRegex: PropTypes.instanceOf(RegExp),
};

export default DownloadMobileAppCallout;
